import * as React from "react";
const SvgPc2 = (props) => (
  <svg
    id="pc2_svg__Calque_1"
    x={0}
    y={0}
    viewBox="0 0 1000 1000"
    style={{
      enableBackground: "new 0 0 1000 1000",
    }}
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css" id="style1645">
      {
        ".pc2_svg__st0{fill:#028283}.pc2_svg__st1{fill:none;stroke:#000;stroke-width:5;stroke-miterlimit:10}.pc2_svg__st2{fill:#fc6541}.pc2_svg__st3{opacity:.2;fill:none;stroke:#dadada;stroke-width:3;stroke-miterlimit:10}.pc2_svg__st7{fill:#fff}.pc2_svg__st9{opacity:.5}.pc2_svg__st12{fill:#000b13;stroke:#000b13;stroke-width:2;stroke-miterlimit:10}.pc2_svg__st17,.pc2_svg__st18{fill-rule:evenodd;clip-rule:evenodd;fill:#ffe5c1}.pc2_svg__st18{fill:#028283}.pc2_svg__st20{opacity:.8}.pc2_svg__st22{fill-rule:evenodd;clip-rule:evenodd;fill:#fed1a3}.pc2_svg__st24{fill:#fffcff}"
      }
    </style>
    <path
      className="pc2_svg__st0"
      d="m899.9 792.4-212.8-20-215.9 20-238.1-20c-1.4 0-2.6-1.2-2.6-2.8V194.8c0-1.5 1.2-2.8 2.6-2.8l233.6 20 213.4-20 219.7 23c1.4 0 2.6 1.2 2.6 2.8v571.8c.1 1.5-1.1 2.8-2.5 2.8z"
      id="pc2_svg__path1647"
    />
    <g id="pc2_svg__g1669">
      <g id="pc2_svg__g1667">
        <path
          className="pc2_svg__st2"
          d="M447.5 102.6c2.8-.5 6.8-.9 12.3-.9 5.6 0 9.7 1.1 12.4 3.3 2.6 2 4.3 5.4 4.3 9.4s-1.3 7.3-3.7 9.6c-3.1 2.9-7.8 4.3-13.1 4.3-1.2 0-2.3-.1-3.1-.2v14.5h-9.1v-40zm9.1 18.4c.8.2 1.7.2 3 .2 4.9 0 7.9-2.5 7.9-6.6 0-3.7-2.5-5.9-7.2-5.9-1.8 0-3.1.1-3.7.3v12z"
          id="pc2_svg__path1651"
        />
        <path
          className="pc2_svg__st2"
          d="m498.8 142.5-.5-2.9h-.2c-1.9 2.3-4.9 3.6-8.4 3.6-6 0-9.5-4.3-9.5-9 0-7.7 6.8-11.3 17.2-11.3v-.4c0-1.6-.8-3.8-5.4-3.8-3 0-6.1 1-8.1 2.2l-1.7-5.8c2-1.2 6-2.6 11.4-2.6 9.8 0 12.9 5.8 12.9 12.7v10.2c0 2.8.1 5.5.5 7.1h-8.2zm-1.1-13.8c-4.8 0-8.5 1.1-8.5 4.6 0 2.4 1.5 3.5 3.6 3.5 2.2 0 4.1-1.5 4.7-3.4.1-.5.2-1 .2-1.6v-3.1z"
          id="pc2_svg__path1653"
        />
        <path
          className="pc2_svg__st2"
          d="M513.8 122.9c0-4.3-.1-7.2-.2-9.7h7.8l.3 5.4h.2c1.5-4.3 5.1-6.1 7.9-6.1.8 0 1.3 0 2 .2v8.6c-.7-.1-1.4-.3-2.5-.3-3.4 0-5.6 1.8-6.3 4.6-.1.6-.2 1.3-.2 2v14.9h-9.1v-19.6z"
          id="pc2_svg__path1655"
        />
        <path
          className="pc2_svg__st2"
          d="M558.6 141.8c-1.6.8-4.7 1.4-8.2 1.4-9.5 0-15.5-5.8-15.5-15 0-8.6 5.9-15.6 16.8-15.6 2.4 0 5.1.4 7 1.2l-1.4 6.8c-1.1-.5-2.7-.9-5.1-.9-4.8 0-7.9 3.4-7.9 8.2 0 5.4 3.6 8.3 8 8.3 2.2 0 3.9-.4 5.3-1l1 6.6z"
          id="pc2_svg__path1657"
        />
        <path
          className="pc2_svg__st2"
          d="M592.6 127.6c0 10.7-7.6 15.6-15.5 15.6-8.5 0-15.2-5.6-15.2-15.1s6.3-15.6 15.7-15.6c9 0 15 6.2 15 15.1zm-21.2.3c0 5 2.1 8.8 6 8.8 3.6 0 5.8-3.6 5.8-8.9 0-4.3-1.7-8.8-5.8-8.8-4.4 0-6 4.5-6 8.9z"
          id="pc2_svg__path1659"
        />
        <path
          className="pc2_svg__st2"
          d="M625.9 133.1c0 3.8.1 7 .2 9.4h-7.9l-.4-4.1h-.2c-1.1 1.8-3.9 4.8-9.2 4.8-6 0-10.3-3.7-10.3-12.8v-17.3h9.1V129c0 4.3 1.4 6.9 4.6 6.9 2.5 0 4-1.7 4.5-3.2.2-.5.3-1.2.3-1.9v-17.5h9.1v19.8z"
          id="pc2_svg__path1661"
        />
        <path
          className="pc2_svg__st2"
          d="M633.2 122.9c0-4.3-.1-7.2-.2-9.7h7.8l.3 5.4h.2c1.5-4.3 5.1-6.1 7.9-6.1.8 0 1.3 0 2 .2v8.6c-.7-.1-1.4-.3-2.5-.3-3.4 0-5.6 1.8-6.3 4.6-.1.6-.2 1.3-.2 2v14.9h-9.1v-19.6z"
          id="pc2_svg__path1663"
        />
        <path
          className="pc2_svg__st2"
          d="M656 134.6c1.7 1 5.2 2.2 7.8 2.2 2.8 0 3.9-.9 3.9-2.4s-.9-2.3-4.3-3.4c-6.1-2-8.4-5.3-8.4-8.8 0-5.5 4.7-9.7 11.9-9.7 3.4 0 6.5.8 8.3 1.7l-1.6 6.3c-1.3-.7-3.9-1.7-6.4-1.7-2.2 0-3.5.9-3.5 2.4 0 1.4 1.2 2.1 4.8 3.4 5.6 1.9 7.9 4.8 7.9 9 0 5.5-4.3 9.5-12.7 9.5-3.8 0-7.3-.9-9.5-2.1l1.8-6.4z"
          id="pc2_svg__path1665"
        />
      </g>
    </g>
    <g id="pc2_svg__g1695">
      <g id="pc2_svg__g1693">
        <path
          className="pc2_svg__st2"
          d="M420.8 905.8h9.1v25.6c0 11.5-5.5 15.5-14.4 15.5-2.1 0-4.9-.3-6.7-1l1-7.4c1.2.4 2.9.7 4.7.7 3.8 0 6.3-1.7 6.3-8v-25.4z"
          id="pc2_svg__path1671"
        />
        <path
          className="pc2_svg__st2"
          d="M447.9 905.2c-1.9 5.9-4.5 11.7-7.2 16.2l-5.5.5c1.8-5.1 3.4-10.9 4.2-16.2l8.5-.5z"
          id="pc2_svg__path1673"
        />
        <path
          className="pc2_svg__st2"
          d="m469.6 946.3-.5-2.9h-.2c-1.9 2.3-4.9 3.6-8.4 3.6-6 0-9.5-4.3-9.5-9 0-7.7 6.8-11.3 17.2-11.3v-.4c0-1.6-.8-3.8-5.4-3.8-3 0-6.1 1-8.1 2.2l-1.7-5.8c2-1.2 6-2.6 11.4-2.6 9.8 0 12.9 5.8 12.9 12.7v10.2c0 2.8.1 5.5.5 7.1h-8.2zm-1.1-13.9c-4.8 0-8.5 1.1-8.5 4.6 0 2.4 1.5 3.5 3.6 3.5 2.2 0 4.1-1.5 4.7-3.4.1-.5.2-1 .2-1.6v-3.1z"
          id="pc2_svg__path1675"
        />
        <path
          className="pc2_svg__st2"
          d="M494 908.7c0 2.5-1.9 4.6-4.9 4.6-2.9 0-4.8-2-4.8-4.6 0-2.6 1.9-4.6 4.8-4.6 3 .1 4.8 2 4.9 4.6zm-9.4 37.6v-29.4h9.1v29.4h-9.1z"
          id="pc2_svg__path1677"
        />
        <path
          className="pc2_svg__st2"
          d="M523.3 908.5v8.4h6.6v6.7h-6.6v10.6c0 3.5.9 5.2 3.6 5.2 1.2 0 2.1-.1 2.7-.3l.1 6.9c-1.2.4-3.4.8-5.9.8-3 0-5.4-1-6.9-2.5-1.7-1.7-2.5-4.5-2.5-8.7v-12h-3.9v-6.7h3.9v-6.3l8.9-2.1z"
          id="pc2_svg__path1679"
        />
        <path
          className="pc2_svg__st2"
          d="M542.2 934.5c.3 3.8 4 5.6 8.3 5.6 3.1 0 5.6-.4 8.1-1.2l1.2 6.2c-3 1.2-6.7 1.9-10.6 1.9-9.9 0-15.7-5.8-15.7-14.9 0-7.5 4.7-15.7 14.8-15.7 9.5 0 13.1 7.4 13.1 14.7 0 1.6-.2 2.9-.3 3.6h-18.9zm10.7-6.2c0-2.2-1-6-5.1-6-3.9 0-5.4 3.5-5.7 6h10.8z"
          id="pc2_svg__path1681"
        />
        <path
          className="pc2_svg__st2"
          d="M566.8 926.6c0-4.3-.1-7.2-.2-9.7h7.8l.3 5.4h.2c1.5-4.3 5.1-6.1 7.9-6.1.8 0 1.3 0 2 .2v8.6c-.7-.1-1.4-.3-2.5-.3-3.4 0-5.6 1.8-6.3 4.6-.1.6-.2 1.3-.2 2v14.9h-9.1v-19.6z"
          id="pc2_svg__path1683"
        />
        <path
          className="pc2_svg__st2"
          d="M589.6 926.3c0-3.7-.1-6.7-.2-9.4h7.7l.4 4h.2c1.2-1.9 3.9-4.6 8.9-4.6 3.8 0 6.8 1.9 8 5h.1c1.1-1.6 2.4-2.8 3.8-3.6 1.6-1 3.4-1.5 5.6-1.5 5.6 0 9.9 4 9.9 12.7v17.3h-8.9v-15.9c0-4.3-1.4-6.7-4.3-6.7-2.1 0-3.6 1.4-4.2 3.2-.2.7-.3 1.6-.3 2.3v17.2h-8.9v-16.5c0-3.7-1.3-6.2-4.2-6.2-2.3 0-3.7 1.8-4.3 3.3-.3.7-.3 1.5-.3 2.3v17.1h-8.9v-20z"
          id="pc2_svg__path1685"
        />
        <path
          className="pc2_svg__st2"
          d="M650.6 908.7c0 2.5-1.9 4.6-4.9 4.6-2.9 0-4.8-2-4.8-4.6 0-2.6 1.9-4.6 4.8-4.6 3 .1 4.9 2 4.9 4.6zm-9.4 37.6v-29.4h9.1v29.4h-9.1z"
          id="pc2_svg__path1687"
        />
        <path
          className="pc2_svg__st2"
          d="M657.7 926.3c0-3.7-.1-6.7-.2-9.4h7.9l.4 4.1h.2c1.2-1.9 4.2-4.7 9.1-4.7 6 0 10.5 4 10.5 12.6v17.4h-9.1V930c0-3.8-1.4-6.4-4.6-6.4-2.5 0-4 1.8-4.6 3.4-.2.6-.3 1.4-.3 2.3v16.9h-9.1v-19.9z"
          id="pc2_svg__path1689"
        />
        <path
          className="pc2_svg__st2"
          d="M699.9 934.5c.3 3.8 4 5.6 8.3 5.6 3.1 0 5.6-.4 8.1-1.2l1.2 6.2c-3 1.2-6.7 1.9-10.6 1.9-9.9 0-15.7-5.8-15.7-14.9 0-7.5 4.7-15.7 14.8-15.7 9.5 0 13.1 7.4 13.1 14.7 0 1.6-.2 2.9-.3 3.6h-18.9zm10.7-6.2c0-2.2-1-6-5.1-6-3.9 0-5.4 3.5-5.7 6h10.8zm5-24.2-7.3 9.1H702l5.2-9.1h8.4z"
          id="pc2_svg__path1691"
        />
      </g>
    </g>
    <path
      className="pc2_svg__st3"
      id="pc2_svg__line1697"
      d="m467.2 215.7 4.8 580"
    />
    <path
      className="pc2_svg__st3"
      id="pc2_svg__line1699"
      d="m680.2 193 4.8 580"
    />
    <path
      d="M893.5 786.6 684.9 767l-211.8 19.6L239.5 767c-1.4 0-2.5-1.2-2.5-2.7V200.5c0-1.5 1.1-2.7 2.5-2.7l229.2 19.6L678 197.8l215.5 22.6c1.4 0 2.5 1.2 2.5 2.7v560.8c.1 1.5-1.1 2.7-2.5 2.7z"
      id="pc2_svg__path1717"
      style={{
        fill: "none",
        stroke: "#ededed",
        strokeWidth: 3,
        strokeMiterlimit: 10,
      }}
    />
    <g id="pc2_svg__g1745">
      <g id="pc2_svg__g1743">
        <path
          className="pc2_svg__st7"
          d="M380.7 651.8h-9.4v-8.3h29v8.3h-9.6v28.7h-9.9v-28.7z"
          id="pc2_svg__path1719"
        />
        <path
          className="pc2_svg__st7"
          d="M414.8 643.5v37.1h-9.9v-37.1h9.9z"
          id="pc2_svg__path1721"
        />
        <path
          className="pc2_svg__st7"
          d="M428.9 651.8h-9.4v-8.3h29v8.3h-9.6v28.7H429v-28.7z"
          id="pc2_svg__path1723"
        />
        <path
          className="pc2_svg__st7"
          d="M453 644c2.8-.4 7-.8 12-.8 5.7 0 9.7.8 12.5 2.9 2.4 1.8 3.7 4.5 3.7 8.1 0 4.6-3.5 7.9-6.3 9v.2c2.5 1.1 3.8 3.4 4.7 6.6 1.1 3.8 2.3 9.2 3.1 10.6h-10.1c-.6-1.1-1.5-4-2.6-8.5-1-4.4-2.4-5.4-5.4-5.4H463v13.9h-10V644zm9.8 15.5h2.6c3.7 0 5.9-1.8 5.9-4.6s-1.8-4.4-5.1-4.4c-1.9 0-2.9.1-3.4.2v8.8z"
          id="pc2_svg__path1725"
        />
        <path
          className="pc2_svg__st7"
          d="M510.2 665.6h-13.3v6.8h14.9v8.1H487v-37.1h24v8.1h-14.1v6h13.3v8.1z"
          id="pc2_svg__path1727"
        />
        <path
          className="pc2_svg__st7"
          d="M528.2 644c3.1-.5 7.4-.8 11.8-.8 7.1 0 11.6 1.2 15.2 3.7 4.1 2.8 6.7 7.4 6.7 14.2 0 7.5-2.9 12.5-6.5 15.3-4.1 3.2-10.1 4.6-17.4 4.6-4.8 0-8-.3-9.9-.6V644zm9.9 29.1c.5.1 1.4.1 2.1.1 6.4.1 11.2-3.5 11.2-11.8 0-7.2-4.3-10.7-10.3-10.7-1.6 0-2.5.1-3 .2v22.2z"
          id="pc2_svg__path1729"
        />
        <path
          className="pc2_svg__st7"
          d="M577.1 643.5v21c0 5.6 1.9 8.8 5.9 8.8 3.9 0 5.9-2.9 5.9-8.8v-21h9.9v20.4c0 11.4-5.7 17.2-16.1 17.2-10.1 0-15.5-5.6-15.5-17.5v-20.2h9.9z"
          id="pc2_svg__path1731"
        />
        <path
          className="pc2_svg__st7"
          d="M616.4 644c2.2-.4 7.1-.8 11.7-.8 5.2 0 8.4.4 11.3 1.8 2.9 1.3 5 4 5 7.6 0 3.1-1.7 6.2-6 7.8v.1c4.5 1.2 7.3 4.6 7.3 9 0 3.5-1.7 6.2-4.2 8.1-2.8 2.1-7.4 3.3-15.3 3.3-4.5 0-7.8-.3-9.8-.6V644zm9.8 13.8h2c4.2 0 6.2-1.5 6.2-3.9 0-2.2-1.6-3.5-5-3.5-1.7 0-2.6.1-3.2.2v7.2zm0 15.8c.7.1 1.6.1 2.9.1 3.3 0 6.1-1.3 6.1-4.6 0-3.1-2.9-4.3-6.6-4.3h-2.4v8.8z"
          id="pc2_svg__path1733"
        />
        <path
          className="pc2_svg__st7"
          d="m660.8 672-2.1 8.6h-10.3l10.7-37.1h13.2l11 37.1h-10.7l-2.4-8.6h-9.4zm8.2-7.4-1.7-6.7c-.6-2.1-1.3-5.1-1.8-7.3h-.1c-.5 2.2-1.1 5.2-1.6 7.3l-1.6 6.6h6.8z"
          id="pc2_svg__path1735"
        />
        <path
          className="pc2_svg__st7"
          d="M688.2 644c3.1-.5 7.4-.8 11.8-.8 7.1 0 11.6 1.2 15.2 3.7 4.1 2.8 6.7 7.4 6.7 14.2 0 7.5-2.9 12.5-6.5 15.3-4.1 3.2-10.1 4.6-17.4 4.6-4.8 0-8-.3-9.9-.6V644zm9.9 29.1c.5.1 1.4.1 2.1.1 6.4.1 11.2-3.5 11.2-11.8 0-7.2-4.3-10.7-10.3-10.7-1.6 0-2.5.1-3 .2v22.2z"
          id="pc2_svg__path1737"
        />
        <path
          className="pc2_svg__st7"
          d="M759.4 678.8c-2.8.9-8 2.1-12.8 2.1-7.3 0-12.3-1.8-15.6-5-3.5-3.3-5.3-8.1-5.3-13.4.1-12.9 9.6-19.4 21.6-19.4 5 0 8.8.9 10.7 1.8l-2 7.9c-2.1-.9-4.6-1.6-8.8-1.6-6.1 0-11.2 3.2-11.2 10.7 0 6.9 4.5 10.9 10.6 10.9 1.4 0 2.6-.1 3.1-.3v-6.4h-5v-7.7h14.5v20.4z"
          id="pc2_svg__path1739"
        />
        <path
          className="pc2_svg__st7"
          d="M788.8 665.6h-13.3v6.8h14.9v8.1h-24.8v-37.1h24v8.1h-14.1v6h13.3v8.1z"
          id="pc2_svg__path1741"
        />
      </g>
    </g>
    <g className="pc2_svg__st9" id="pc2_svg__g1794">
      <g id="pc2_svg__g1761">
        <path
          d="m114.9 647.1 6.2-9.7 4.9 3.1-6.2 9.7-4.9-3.1z"
          id="pc2_svg__path1749"
        />
        <path
          d="m97.3 639.3 3.7-10.9 5.5 1.9-3.7 10.9-5.5-1.9z"
          id="pc2_svg__path1751"
        />
        <path d="M78.1 625.4h5.8V637h-5.8v-11.6z" id="pc2_svg__path1753" />
        <path
          d="m55.5 630.2 5.5-1.9 3.7 10.9-5.5 1.9-3.7-10.9z"
          id="pc2_svg__path1755"
        />
        <path
          d="m36 640.5 4.9-3.1 6.2 9.7-4.9 3.1-6.2-9.7z"
          id="pc2_svg__path1757"
        />
        <path
          d="m128.7 673.4 1.5-1.9-1.6-1.8c-.2-.2-5.3-6.1-13.7-12-11.2-7.9-22.9-12.1-34-12.1-11 0-22.8 4.2-33.9 12.1-8.4 5.9-13.5 11.8-13.7 12l-1.6 1.9 1.6 1.9c.2.2 5.3 6.1 13.7 12 11.2 7.9 22.9 12.1 33.9 12.1 5.5 0 11.2-1 16.9-3 .4.7.9 1.3 1.4 1.9l14.3 14.3 12.2-12.2-12-12c9.4-6.4 14.7-12.9 15-13.2zM91.2 676c-5.6 5.6-14.8 5.6-20.4 0-2.7-2.7-4.2-6.3-4.2-10.2 0-3.9 1.5-7.5 4.2-10.2 2.8-2.8 6.5-4.2 10.2-4.2s7.4 1.4 10.2 4.2c2.7 2.7 4.2 6.3 4.2 10.2 0 3.8-1.5 7.5-4.2 10.2zm-40.7 4.8c-5.1-3.6-8.9-7.2-11-9.3 2.1-2.1 5.9-5.7 11-9.3 3.6-2.5 8.2-5.3 13.5-7.4-2.1 3.2-3.2 7-3.2 10.9 0 5.4 2.1 10.5 5.9 14.3 3.9 3.9 9.1 5.9 14.3 5.9 4.3 0 8.5-1.3 12.1-4l4.6 4.6c-.3.7-.6 1.4-.7 2.2-5.4 2-10.8 3.1-16 3.1-12.4 0-23.4-6-30.5-11zm63.1 21.7-10.2-10.2c-1.1-1.1-1.1-3 0-4.1 1.1-1.1 3-1.1 4.1 0l10.2 10.2-4.1 4.1zm-4.3-20c-2.4-1.2-5.2-1.2-7.6 0l-4.6-4.6c2.6-3.5 4-7.7 4-12.1 0-3.9-1.1-7.7-3.2-10.9 5.3 2.1 9.9 4.9 13.5 7.4 5.1 3.6 9 7.2 11 9.3-2.2 2.4-6.8 6.8-13.1 10.9z"
          id="pc2_svg__path1759"
        />
      </g>
      <g id="pc2_svg__g1788">
        <g id="pc2_svg__g1767">
          <g id="pc2_svg__g1765">
            <path
              d="m91.2 680.2 4.1-4.1 8.2 8.1-4.1 4.1-8.2-8.1z"
              id="pc2_svg__path1763"
              style={{
                stroke: "#000b13",
                strokeWidth: 2,
                strokeMiterlimit: 10,
              }}
            />
          </g>
        </g>
        <g id="pc2_svg__Vision_1_">
          <g id="pc2_svg__g1773">
            <g id="pc2_svg__g1771">
              <path
                d="m113.7 710.7-14.3-14.2c-2.8-2.7-3.8-8.4 0-12.2 3.1-3.1 8-3.4 11.4-.7 12.4 12.3 15.7 15.5 15.1 14.9l-12.2 12.2z"
                id="pc2_svg__path1769"
                style={{
                  fill: "#028283",
                  stroke: "#000b13",
                  strokeWidth: 3,
                  strokeMiterlimit: 10,
                }}
              />
            </g>
          </g>
        </g>
        <g id="pc2_svg__g1784">
          <g id="pc2_svg__g1782">
            <g id="pc2_svg__g1780">
              <g id="pc2_svg__g1778">
                <path
                  className="pc2_svg__st12"
                  d="M66.7 680.2c-7.9-7.9-7.9-20.6 0-28.5 7.6-7.6 21-7.6 28.6 0 7.9 7.9 7.9 20.6 0 28.5-7.9 7.9-20.7 7.8-28.6 0z"
                  id="pc2_svg__path1776"
                />
              </g>
            </g>
          </g>
        </g>
        <path
          className="pc2_svg__st12"
          d="M81 646v40.1c5.2 0 10.4-2 14.3-5.9 7.9-7.9 7.9-20.6 0-28.5-3.9-3.8-9.1-5.7-14.3-5.7z"
          id="pc2_svg__path1786"
        />
      </g>
      <ellipse
        cx={81.2}
        cy={666}
        rx={11.8}
        ry={11.6}
        id="pc2_svg__ellipse1790"
        style={{
          fill: "#fffcff",
          stroke: "#fffcff",
          strokeWidth: 5,
          strokeMiterlimit: 10,
        }}
      />
      <ellipse
        cx={81.2}
        cy={666}
        rx={5.9}
        ry={5.8}
        id="pc2_svg__ellipse1792"
        style={{
          fill: "none",
          stroke: "#fc6541",
          strokeWidth: 4,
          strokeMiterlimit: 10,
        }}
      />
    </g>
    <g className="pc2_svg__st9" id="pc2_svg__g1874">
      <g id="pc2_svg__g1798">
        <path
          d="m97.2 307.8 20.6 19.9 4 3.9 1.5 1.4c.5.5 1.2.4 1.7 0l4.1-4.2 3.7-3.9c1.6-1.7 1.6-4.4-.1-6.1l-3.6-3.5-20-19.2c-1.7-1.6-4.4-1.6-6.1.1l-7.8 8.1c-.5.5-.4 1.2 0 1.7l2 1.8z"
          id="pc2_svg__path1796"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fc6541",
          }}
        />
      </g>
      <g id="pc2_svg__g1802">
        <path
          d="m68.5 309.1-22.2 21.3c.7 5.9 1.8 11.4 5.4 14.5l30.1 24.4 3.6 2.8c5.5 4.2 10.7-1.7 6.5-6l-.2-.2c1.4 1.2 3 1.5 4.4 1.3 3-.5 5.1-3.7 2.3-6.7 5.5 4.4 10.1-2.6 5.9-6.4 4.8 1.5 10-4.7 5-9.9l-.1-.1-12.4-18.5-16.7-10.7-11.6-5.8z"
          id="pc2_svg__path1800"
          style={{
            opacity: 0.65,
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#ffbc85",
          }}
        />
      </g>
      <g id="pc2_svg__g1806">
        <path
          className="pc2_svg__st17"
          d="M81.4 369.8c4.6-4.9-2.1-10.6-5.9-7.3l-4 3.8-.1.1c-3.4 3.4 2.7 11 7.8 5.7l2.2-2.3z"
          id="pc2_svg__path1804"
        />
      </g>
      <g id="pc2_svg__g1810">
        <path
          className="pc2_svg__st17"
          d="m68.6 355.7-4.2 4.4c-2.1 2.2-.6 5.7 1.9 7 1.6.8 3.5.9 5.2-.7l4.5-.1-.4-3.9.6-.5c4.5-4.3-2-11.7-7.1-6.8l-.5.6z"
          id="pc2_svg__path1808"
        />
      </g>
      <g id="pc2_svg__g1814">
        <path
          className="pc2_svg__st17"
          d="m61 349.6-4 4.2-.6.6c-3.9 4.1 3.1 10.7 7.1 6.4l.7-.7c.1-.1 4.3-.5 4.8-.6l-.1-4.4 1.4-1.4c4.7-4.9-2.6-11.3-7.1-6.6l-2.2 2.5z"
          id="pc2_svg__path1812"
        />
      </g>
      <g id="pc2_svg__g1818">
        <path
          className="pc2_svg__st17"
          d="m51.8 344.9-1.3 1.5c-4.1 4.5 2 11.6 6.6 7.5l3.8-.6.2-3.6c3.7-4.2-2.8-11.8-7.9-6.2l-1.4 1.4z"
          id="pc2_svg__path1816"
        />
      </g>
      <g id="pc2_svg__g1822">
        <path
          className="pc2_svg__st18"
          d="M57.4 296.5 39 314.2l-5.2 5c-1.7 1.6-1.8 4.4-.1 6.1l7.8 8.1c.5.5 1.2.5 1.7 0l3.1-3 22.2-21.3 2.8-2.7c.5-.5.5-1.2 0-1.7l-7.8-8.1c-1.6-1.7-4.4-1.8-6.1-.1z"
          id="pc2_svg__path1820"
        />
      </g>
      <g id="pc2_svg__g1826">
        <path
          d="m92.4 327.2-5.6 1.3 2.2 2.2 16.9 16.8.1.1c2 2.2 2.4 4.5 1.7 6.3 3.3-1.3 5.5-5.8 1.7-9.8l-.1-.1-5.1-5-11.8-11.8z"
          id="pc2_svg__path1824"
          style={{
            opacity: 0.8,
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#f5a96c",
          }}
        />
      </g>
      <g className="pc2_svg__st20" id="pc2_svg__g1830">
        <path
          d="m68.5 309.1-3.6 3.4L76 318l4.1-3.2-11.6-5.7z"
          id="pc2_svg__path1828"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#f5a96c",
          }}
        />
      </g>
      <g id="pc2_svg__g1834">
        <path
          className="pc2_svg__st17"
          d="M80.1 314.8 76 318l-3.8 3c-9.7 7.5-1.7 14.9 4.1 12.4l6.5-3.9 4-.9 5.6-1.3 11.8 11.8 5.1 5c3.2-1.2 7.7-4.6 12.6-12.5l-24.7-23.7-4.4 3.5c-.7.6-.5.5-1.4.4-3.3-.1-7.6.2-10 2.1l-1.3.9z"
          id="pc2_svg__path1832"
        />
      </g>
      <g id="pc2_svg__g1838">
        <path
          className="pc2_svg__st22"
          d="m80.1 326.8-6.5 3.9c-1.8.8-3.7.6-5.4-.2 1.4 2.7 5 4.1 8 2.8l6.5-3.9 4-.9 5.5-1.3c-2.6-2.2-3-2.5-8.2-1.3l-3.9.9z"
          id="pc2_svg__path1836"
        />
      </g>
      <g id="pc2_svg__g1842">
        <path
          className="pc2_svg__st22"
          d="M117.8 327.6c-4.3 7-8.4 10.5-11.5 12-.3.2-.7.3-1 .4l3.9 3.9c3.2-1.2 7.7-4.6 12.6-12.5l-4-3.8z"
          id="pc2_svg__path1840"
        />
      </g>
      <g id="pc2_svg__g1846">
        <path
          d="M127.5 313.8zm-3.6 9.9-4.1 4.2c-.5.5-1.2.5-1.7 0l3.7 3.5 1.5 1.4c.5.5 1.2.4 1.7 0l4.1-4.2 3.7-3.9c1.6-1.7 1.6-4.4-.1-6.1l-4.6-4.4.4.4-1-.9c1.7 1.6 1.7 4.3.1 6l-3.7 4z"
          id="pc2_svg__path1844"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fb2a39",
          }}
        />
      </g>
      <g id="pc2_svg__g1850">
        <path
          className="pc2_svg__st18"
          d="M51.2 302.5c1.7-1.6 4.4-1.6 6 .1l7.8 8.1c.5.5.4 1.2 0 1.7l3.6-3.4 2.8-2.7c.5-.5.5-1.2 0-1.7l-7.8-8.1c-1.6-1.7-4.4-1.8-6.1-.1l-6.3 6.1z"
          id="pc2_svg__path1848"
        />
      </g>
      <g id="pc2_svg__g1854">
        <path
          className="pc2_svg__st22"
          d="M49.1 349.8c0 3.8 4.5 7.2 8 4.1l2.5-2.6 1.5-1.6c1.5-1.7 1.3-4.1.2-5.8 0 1-.3 2-1.1 2.9l-2.6 2.8-1.3 1.4c-2.7 2.2-5.7 1-7.2-1.2z"
          id="pc2_svg__path1852"
        />
      </g>
      <g id="pc2_svg__g1858">
        <path
          className="pc2_svg__st22"
          d="M55.6 358.4c.9 3.1 5.2 5.5 8.1 2.5l.7-.7 4.2-4.4c.2-.2.3-.3.4-.5l1.4-1.4c2.5-2.6 1.6-5.7-.6-7.3.4 1.4.1 3.1-1.3 4.5l-1.4 1.4c-.2.1-.3.3-.4.5l-4.2 4.4-.7.7c-1.9 2-4.5 1.6-6.2.3z"
          id="pc2_svg__path1856"
        />
      </g>
      <g id="pc2_svg__g1862">
        <path
          className="pc2_svg__st22"
          d="m71.5 366.4 3.1-2.9.9-.9.6-.5c2.4-2.3 1.7-5.5-.3-7.2.4 1.5.1 3.2-1.3 4.6l-.6.5-1.6 1.5-2.4 2.3-.1.1c-1.7 1.6-3.7 1.5-5.2.7-.4-.2-.7-.5-1.1-.8.4 1.4 1.4 2.6 2.7 3.3 1.6.8 3.5.9 5.2-.7h.1z"
          id="pc2_svg__path1860"
        />
      </g>
      <g id="pc2_svg__g1866">
        <path
          className="pc2_svg__st22"
          d="M81.4 369.8c2.3-2.5 1.8-5.1.2-6.7 0 1.1-.5 2.3-1.6 3.4l-2.2 2.3c-2.7 2.9-5.7 2-7.4.1 0 3.5 4.7 7.5 8.7 3.3l2.3-2.4z"
          id="pc2_svg__path1864"
        />
      </g>
      <g id="pc2_svg__g1870">
        <path
          d="M92 367.6c-.4 0-.8-.1-1-.4l-3.1-2.9c-.6-.6-.7-1.6-.1-2.2.6-.6 1.6-.7 2.2-.1l3.1 2.9c.6.6.7 1.6.1 2.2-.4.4-.8.5-1.2.5z"
          id="pc2_svg__path1868"
        />
      </g>
      <path
        d="m133.7 317.6-23.6-22.7c-1.1-1.1-2.6-1.6-4.2-1.6s-3 .7-4.1 1.8l-7.8 8.1c-1 1.1-1 2.8.1 3.9l.6.6-3.2 2.6h-.3c-5-.2-8.7.7-11 2.5l-.4.3-8.8-4.3 1.2-1.1c.5-.5.8-1.2.8-1.9s-.3-1.4-.8-2l-7.8-8.1c-1.1-1.1-2.5-1.8-4.1-1.8-1.6 0-3 .5-4.2 1.6l-23.6 22.7c-2.3 2.2-2.4 5.9-.2 8.2l7.8 8.1c.5.6 1.2.8 2 .8.7 0 1.4-.3 1.9-.8l.9-.9c.7 4.2 1.8 8.4 4.4 11.3l-.3.4c-2.8 3-1.9 7.1.3 9.4 1.2 1.3 2.7 1.9 4.2 2-.2 1.9.7 3.9 2.1 5.2 1.3 1.2 2.9 1.9 4.6 1.9.4 0 .8 0 1.3-.1.2 1.4 1 2.7 1.9 3.7 1.2 1.2 2.8 2 4.6 2h.5c0 .3.1.7.2 1 .6 2.4 2.6 4.5 4.9 5.1.4.1.9.2 1.5.2 1.4 0 3.1-.5 4.9-2.3l1.7-1.8 2.5 1.9c1.6 1.3 3.3 1.8 4.7 1.8 1.8 0 3.4-.8 4.4-2 1-1.1 1.5-2.7 1.3-4.4 1.9.1 3.7-.6 4.9-1.9.9-.9 1.4-2.2 1.4-3.5 2 .2 3.7-.6 4.8-1.9 1.2-1.5 1.8-3.7 1.1-5.8 1.8-.4 3.5-1.6 4.6-3.3 1.2-2 1.7-4.9-.2-7.8 2.8-1.5 6.4-4.6 10.4-10.6l.1.1c.5.5 1.2.8 1.9.8s1.4-.3 2-.8l7.8-8.1c2.7-2.6 2.6-6.3.3-8.5zm-82.1 29.8 2.7-2.9c1.1-1.2 2.3-1.7 3.5-1.4 1.2.3 2.3 1.4 2.7 2.7.2.6.4 1.9-.6 2.9l-3.8 4c-1.6 1.4-3.2.8-4.2-.2-1.3-1.3-1.9-3.4-.3-5.1zm6.5 12.2c-.2-.2-2.2-2.2-.5-4.1l6.8-7.2c.8-.9 1.7-1.2 2.4-1.2.3 0 .5 0 .7.1 1.2.3 2.3 1.3 2.6 2.4.3 1.1 0 2.2-1 3.1l-1.4 1.5-.2.2-5.1 5.3c-1.5 1.7-3.4.7-4.3-.1zm7.9 5.5c-.9-.9-1.7-2.7-.5-3.9l4.2-4.4.1-.1.3-.3c1-1 2.2-1.4 3.3-1.2 1.2.3 2.3 1.3 2.7 2.6.2.8.2 2-.9 3.1l-.5.5-.1.1-3.9 3.7-.1.1c-2.3 1.9-4.2.2-4.6-.2zm12.1 6c-1.1 1.1-2.2 1.6-3.3 1.3-1.2-.3-2.4-1.5-2.7-2.8-.1-.6-.2-1.4.4-2l.1-.1 4-3.8c1.2-1 2.9-.5 3.9.5.5.5 1.9 2.3-.2 4.6l-2.2 2.3zm31.2-20.4c-.8 1.3-2.4 2.3-4.1 1.9l-5.9-5.5c-.6-.6-1.6-.5-2.2.1-.6.6-.5 1.6.1 2.2l6.2 5.7c1.5 1.4 1.4 3.2.5 4.2-1 1.2-2.6 1.2-4.3-.2l-6.1-5.7c-.6-.6-1.6-.5-2.2.1-.6.6-.5 1.6.1 2.2l6.1 5.7c1.1 1.2 1.2 2.3.3 3.2-1 1.1-3.1 1.4-4.9-.1-.6-.5-1.6-.5-2.1.1-.6.6-.5 1.6.1 2.1 1.7 1.6 1.4 3.2.6 4.1-.9 1.1-2.8 1.4-4.9-.2l-2.5-1.9c1.3-2.6.5-5.2-1.2-6.9-1-1-2.3-1.7-3.7-1.9.2-1 .2-2 0-3.1-.6-2.4-2.6-4.3-4.9-4.8-.3-.1-.6-.1-.9-.1.3-1.1.3-2.2 0-3.4-.7-2.2-2.6-4-4.8-4.5-1.7-.4-3.4-.1-4.9.9 0-.1 0-.1-.1-.2-.7-2.4-2.7-4.3-5-4.8s-4.6.3-6.4 2.3l-.2.3c-2.2-2.6-3.1-6.6-3.8-11.7l6.5-6.3c.6-.6.6-1.6 0-2.2-.6-.6-1.6-.6-2.2 0l-7 6.7c-.1 0-.1.1-.2.1l-2.8 2.7-7.5-7.9c-1-1.1-1-2.8.1-3.9l23.6-22.7c.5-.5 1.2-.8 2-.8.7 0 1.4.3 1.9.8l7.5 7.9-12.7 12.3c-.6.6-.6 1.6 0 2.2.6.6 1.6.6 2.2 0l9.5-9.1 8.4 4.2-6 4.6c-7.1 5.5-5 10.5-4.2 11.9 1.4 2.4 4 3.8 6.7 3.8 1 0 2.1-.2 3.1-.6.1 0 .1-.1.2-.1l6.3-3.8 8.5-1.9 16.3 16.2c2.3 2.8 1.4 5 .9 5.8zm22.4-27-7.5 7.9-1.2-1.1-.1-.1-10.6-10.2c-.6-.6-1.6-.6-2.2 0-.6.6-.6 1.6 0 2.2l9.8 9.4c-4.3 6.6-8 9.3-10.2 10.4l-16.1-16-.1-.1-.1-.1H92l-9.6 2.2c-.2 0-.3.1-.5.2l-6.4 3.8c-2.1.9-4.7 0-5.9-1.9-1.3-2.3-.1-5.2 3.4-7.9l7.9-6.1 1.1-.8c1.7-1.3 4.9-2 9-1.8h.3c.9.1 1.3-.1 2-.7l3.5-2.8 7.9 7.6c.6.6 1.6.6 2.2 0 .6-.6.6-1.6 0-2.2l-10.5-10.1 7.5-7.9c.5-.5 1.2-.8 1.9-.8h.1c.7 0 1.4.3 1.9.8l23.6 22.7c1.3.6 1.3 2.3.3 3.4z"
        id="pc2_svg__path1872"
      />
    </g>
    <g id="pc2_svg__g1894">
      <path
        className="pc2_svg__st0"
        d="M107.9 485.3v4.5c0 1.6-1.1 2.9-2.6 3.2l-8.2 1.6c-.6 2-1.4 4-2.4 5.8l4.6 6.9c.9 1.3.7 3-.4 4.1l-3.1 3.1c-1.1 1.1-2.8 1.3-4.1.4l-6.9-4.6c-1.8 1-3.7 1.8-5.8 2.4l-1.6 8.2c-.3 1.5-1.6 2.6-3.2 2.6h-4.5c-1.6 0-2.9-1.1-3.2-2.6l-1.6-8.2c-2-.6-4-1.4-5.8-2.4l-6.9 4.6c-1.3.9-3 .7-4.1-.4l-3.1-3.1c-1.1-1.1-1.3-2.8-.4-4.1l4.6-6.9c-1-1.8-1.8-3.7-2.4-5.8l-8.2-1.6c-1.5-.3-2.6-1.6-2.6-3.2v-4.5c0-1.6 1.1-2.9 2.6-3.2l8.2-1.6c.6-2 1.4-4 2.4-5.8l-4.6-6.9c-.9-1.3-.7-3 .4-4.1l3.1-3.1c1.1-1.1 2.8-1.3 4.1-.4l6.9 4.6c1.8-1 3.7-1.8 5.8-2.4l1.6-8.2c.3-1.5 1.6-2.6 3.2-2.6h4.5c1.6 0 2.9 1.1 3.2 2.6l1.6 8.2c2 .6 4 1.4 5.8 2.4l6.9-4.6c1.3-.9 3-.7 4.1.4l3.1 3.1c1.1 1.1 1.3 2.8.4 4.1l-4.6 6.9c1 1.8 1.8 3.7 2.4 5.8l8.2 1.6c1.5.3 2.6 1.6 2.6 3.2z"
        id="pc2_svg__path1876"
      />
      <path
        className="pc2_svg__st24"
        d="M87.7 487.5c0 8.7-7.1 15.8-15.8 15.8s-15.8-7.1-15.8-15.8 7.1-15.8 15.8-15.8 15.8 7.1 15.8 15.8z"
        id="pc2_svg__path1878"
      />
      <path
        className="pc2_svg__st24"
        d="M79.8 487.5c0 4.3-3.5 7.9-7.9 7.9s-7.9-3.5-7.9-7.9 3.5-7.9 7.9-7.9 7.9 3.6 7.9 7.9z"
        id="pc2_svg__path1880"
      />
      <path
        className="pc2_svg__st24"
        d="M75 487.5c0 3.5-2.3 6.5-5.5 7.5a7.864 7.864 0 0 1 0-15c3.2 1 5.5 4 5.5 7.5z"
        id="pc2_svg__path1882"
      />
      <path
        className="pc2_svg__st2"
        d="M130.5 521v2.9c0 1-.7 1.9-1.7 2.1l-5.4 1.1c-.4 1.3-.9 2.6-1.6 3.8l3 4.5c.6.9.5 2-.3 2.7l-2.1 2.1c-.7.7-1.9.8-2.7.3l-4.5-3c-1.2.7-2.4 1.2-3.8 1.6l-1.1 5.4c-.2 1-1.1 1.7-2.1 1.7h-2.9c-1 0-1.9-.7-2.1-1.7l-1.1-5.4c-1.3-.4-2.6-.9-3.8-1.6l-4.5 3c-.9.6-2 .5-2.7-.3l-2.1-2.1c-.7-.7-.8-1.9-.3-2.7l3-4.5c-.7-1.2-1.2-2.4-1.6-3.8L85 526c-1-.2-1.7-1.1-1.7-2.1V521c0-1 .7-1.9 1.7-2.1l5.4-1.1c.4-1.3.9-2.6 1.6-3.8l-3-4.5c-.6-.9-.5-2 .3-2.7l2.1-2.1c.7-.7 1.9-.8 2.7-.3l4.5 3c1.2-.7 2.4-1.2 3.8-1.6l1.1-5.4c.2-1 1.1-1.7 2.1-1.7h2.9c1 0 1.9.7 2.1 1.7l1.1 5.4c1.3.4 2.6.9 3.8 1.6l4.5-3c.9-.6 2-.5 2.7.3l2.1 2.1c.7.7.8 1.9.3 2.7l-3 4.5c.7 1.2 1.2 2.4 1.6 3.8l5.4 1.1c.7.2 1.4 1.1 1.4 2.1z"
        id="pc2_svg__path1884"
      />
      <path
        className="pc2_svg__st24"
        d="M118.7 522.4c0 6.5-5.3 11.8-11.8 11.8s-11.8-5.3-11.8-11.8 5.3-11.8 11.8-11.8 11.8 5.3 11.8 11.8z"
        id="pc2_svg__path1886"
      />
      <path
        className="pc2_svg__st24"
        d="M114 522.4c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.1-3.2-7.1-7.1s3.2-7.1 7.1-7.1c3.9.1 7.1 3.2 7.1 7.1z"
        id="pc2_svg__path1888"
      />
      <path
        className="pc2_svg__st24"
        d="M109.3 522.4c0 3.1-2 5.7-4.7 6.7-2.8-1-4.7-3.6-4.7-6.7s2-5.7 4.7-6.7c2.7 1 4.7 3.7 4.7 6.7z"
        id="pc2_svg__path1890"
      />
      <path
        d="M58.5 482.8c-.5 1.5-.8 3-.8 4.6 0 7.9 6.4 14.3 14.3 14.3 3 0 5.9-.9 8.3-2.7.7-.5 1.7-.3 2.2.3.5.7.3 1.7-.3 2.2-3 2.1-6.5 3.3-10.2 3.3-9.6 0-17.3-7.8-17.3-17.3 0-1.9.3-3.8.9-5.6.3-.8 1.2-1.2 2-1 .7.3 1.1 1.1.9 1.9zm26.8 13.3c.2.1.5.2.7.2.6 0 1.1-.3 1.4-.8 1.2-2.4 1.9-5.2 1.9-7.9 0-9.6-7.8-17.3-17.3-17.3-4.5 0-8.8 1.7-12.1 4.9-.6.6-.6 1.6 0 2.2.6.6 1.6.6 2.2 0 2.7-2.6 6.2-4 9.9-4 7.9 0 14.3 6.4 14.3 14.3 0 2.3-.5 4.5-1.6 6.5-.5.5-.2 1.5.6 1.9zm-.7 14.4c-.4-.8-1.3-1.1-2.1-.7-1.3.6-2.6 1.1-3.9 1.5-.6.2-1 .6-1.1 1.2l-1.6 8.2c-.2.8-.9 1.4-1.7 1.4h-4.5c-.8 0-1.5-.6-1.7-1.4l-1.6-8.2c-.1-.6-.5-1-1.1-1.2-1.9-.5-3.7-1.3-5.4-2.2-.5-.3-1.1-.3-1.6.1l-6.9 4.6c-.7.5-1.6.4-2.2-.2l-3.1-3.1c-.6-.6-.7-1.5-.2-2.2l4.6-6.9c.3-.5.3-1.1.1-1.6-1-1.7-1.7-3.5-2.2-5.4-.2-.6-.6-1-1.2-1.1l-8.2-1.6c-.8-.2-1.4-.9-1.4-1.7v-4.5c0-.8.6-1.5 1.4-1.7l8.2-1.6c.6-.1 1-.5 1.2-1.1.5-1.9 1.3-3.7 2.2-5.4.3-.5.3-1.1-.1-1.6l-4.6-6.9c-.5-.7-.4-1.6.2-2.2l3.1-3.1c.6-.6 1.5-.7 2.2-.2l6.9 4.6c.5.3 1.1.3 1.6.1 1.7-1 3.5-1.7 5.4-2.2.6-.2 1-.6 1.1-1.2l1.6-8.2c.2-.8.9-1.4 1.7-1.4h4.5c.8 0 1.5.6 1.7 1.4l1.6 8.2c.1.6.5 1 1.1 1.2 1.9.5 3.7 1.3 5.4 2.2.5.3 1.1.3 1.6-.1l6.9-4.6c.7-.5 1.6-.4 2.2.2l3.1 3.1c.6.6.7 1.5.2 2.2l-4.6 6.9c-.3.5-.3 1.1-.1 1.6 1 1.7 1.7 3.5 2.2 5.4.2.6.6 1 1.2 1.1l8.2 1.6c.8.2 1.4.9 1.4 1.7v4.5c0 .8-.6 1.5-1.4 1.7l-8.2 1.6c-.6.1-1 .5-1.2 1.1-.4 1.4-.9 2.7-1.5 4-.4.8 0 1.7.7 2.1.8.4 1.7 0 2.1-.7.6-1.2 1-2.4 1.4-3.6l7.2-1.4c2.2-.4 3.9-2.4 3.9-4.7v-4.5c0-2.3-1.6-4.3-3.9-4.7l-7.2-1.4c-.5-1.5-1.1-3-1.8-4.3l4.1-6.2c1.3-1.9 1-4.5-.6-6.1l-3.1-3.1c-1.6-1.6-4.2-1.9-6.1-.6l-6.2 4.1c-1.4-.7-2.8-1.3-4.3-1.8l-1.4-7.2c-.4-2.2-2.4-3.9-4.7-3.9h-4.5c-2.3 0-4.3 1.6-4.7 3.9l-1.4 7.2c-1.5.5-3 1.1-4.3 1.8l-6.1-4.1c-1.9-1.3-4.5-1-6.1.6l-3.1 3.1c-1.6 1.6-1.9 4.2-.6 6.1l4.1 6.2c-.7 1.4-1.3 2.8-1.8 4.3l-7.2 1.4c-2.2.4-3.9 2.4-3.9 4.7v4.5c0 2.3 1.6 4.3 3.9 4.7l7.2 1.4c.5 1.5 1.1 3 1.8 4.3l-4.1 6.2c-1.3 1.9-1 4.5.6 6.1l3.1 3.1c1.6 1.6 4.2 1.9 6.1.6l6.2-4.1c1.4.7 2.8 1.3 4.3 1.8l1.4 7.2c.4 2.2 2.4 3.9 4.7 3.9h4.5c2.3 0 4.3-1.6 4.7-3.9l1.4-7.2c1.2-.4 2.4-.8 3.5-1.4.8-.6 1.1-1.6.8-2.3zm22.3 6.4c3.1 0 5.6 2.5 5.6 5.6 0 .9.7 1.5 1.5 1.5.9 0 1.5-.7 1.5-1.5 0-4.8-3.9-8.6-8.6-8.6s-8.6 3.9-8.6 8.6 3.9 8.6 8.6 8.6c1.9 0 3.8-.6 5.3-1.8.7-.5.8-1.5.3-2.2-.5-.7-1.5-.8-2.2-.3-1 .8-2.2 1.2-3.4 1.2-3.1 0-5.6-2.5-5.6-5.6.1-3 2.5-5.5 5.6-5.5zm-35-20c-5.2 0-9.4-4.2-9.4-9.4s4.2-9.4 9.4-9.4 9.4 4.2 9.4 9.4-4.2 9.4-9.4 9.4zm0-3.1c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.3-6.3-6.3-6.3 2.8-6.3 6.3 2.9 6.3 6.3 6.3zm57.2 23.6-4.5-.9c-.3-.8-.6-1.6-1-2.4l2.5-3.8c1-1.5.8-3.4-.5-4.7l-2.1-2.1c-1.2-1.2-3.2-1.4-4.7-.5l-3.8 2.5c-.8-.4-1.6-.7-2.4-1l-.9-4.5c-.3-1.7-1.9-3-3.6-3h-2.9c-1.8 0-3.3 1.2-3.6 3l-.9 4.5c-.8.3-1.6.6-2.4 1l-3.8-2.5c-1.5-1-3.4-.8-4.7.5l-2.1 2.1c-1.2 1.2-1.4 3.2-.5 4.7l2.5 3.8c-.5 1-.9 2.1-1.3 3.3-.2.8.2 1.7 1.1 1.9.8.2 1.7-.2 1.9-1.1.3-1.2.8-2.4 1.4-3.4.3-.5.3-1.1-.1-1.6l-3-4.5c-.2-.2-.1-.6.1-.8l2.1-2.1c.2-.2.5-.2.8-.1l4.5 3c.5.3 1.1.3 1.6.1 1.1-.6 2.2-1.1 3.4-1.4.6-.2 1-.6 1.1-1.2l1.1-5.4c.1-.3.3-.5.6-.5h2.9c.3 0 .5.2.6.5l1.1 5.4c.1.6.5 1 1.1 1.2 1.2.3 2.4.8 3.4 1.4.5.3 1.1.3 1.6-.1l4.5-3c.2-.2.6-.1.8.1l2.1 2.1c.2.2.2.5.1.8l-3 4.5c-.3.5-.3 1.1-.1 1.6.6 1.1 1.1 2.2 1.4 3.4.2.6.6 1 1.2 1.1l5.4 1.1c.3.1.5.3.5.6v2.9c0 .3-.2.5-.5.6l-5.4 1.1c-.6.1-1 .5-1.2 1.1-.3 1.2-.8 2.4-1.4 3.4-.3.5-.3 1.1.1 1.6l3 4.5c.2.2.1.6-.1.8l-2.1 2.1c-.2.2-.5.2-.8.1l-4.5-3c-.5-.3-1.1-.3-1.6-.1-1.1.6-2.2 1.1-3.4 1.4-.6.2-1 .6-1.1 1.2l-1.1 5.4c-.1.3-.3.5-.6.5H105c-.3 0-.5-.2-.6-.5l-1.1-5.4c-.1-.6-.5-1-1.1-1.2-1.2-.3-2.4-.8-3.4-1.4-.5-.3-1.1-.3-1.6.1l-4.5 3c-.2.2-.6.1-.8-.1l-2.1-2.1c-.2-.2-.2-.5-.1-.8l3-4.5c.3-.5.3-1.1.1-1.6-.6-1.1-1.1-2.2-1.4-3.4-.2-.6-.6-1-1.2-1.1l-5.4-1.1c-.3-.1-.5-.3-.5-.6V521c0-.3.2-.5.5-.6l.3-.1c.8-.2 1.4-1 1.2-1.8-.2-.8-1-1.4-1.8-1.2l-.3.1c-1.7.3-3 1.9-3 3.6v2.9c0 1.8 1.2 3.3 3 3.6l4.5.9c.3.8.6 1.6 1 2.4l-2.5 3.8c-1 1.5-.8 3.4.5 4.7l2.1 2.1c1.2 1.2 3.2 1.4 4.7.5l3.8-2.5c.8.4 1.6.7 2.4 1l.9 4.5c.3 1.7 1.9 3 3.6 3h2.9c1.8 0 3.3-1.2 3.6-3l.9-4.5c.8-.3 1.6-.6 2.4-1l3.8 2.5c1.5 1 3.4.8 4.7-.5l2.1-2.1c1.2-1.2 1.4-3.2.5-4.7l-2.5-3.8c.4-.8.7-1.6 1-2.4l4.5-.9c1.7-.3 3-1.9 3-3.6V521c0-1.8-1.3-3.3-3-3.6z"
        id="pc2_svg__path1892"
      />
    </g>
    <path
      className="pc2_svg__st1"
      d="M692.7 122.8h175.5c6.5 0 41.3.6 69.4 26.8 17.7 16.5 28.7 39.4 28.7 64.6v521.1c0 96.6-43.9 137.5-98.1 137.5H259.6c-54.2 0-98.1-40.9-98.1-91.4V572.6c0-.6-.5-1-1.1-1.1-1.8-.1-5.3-.2-7.8-.1-8.3.1-119.3-.1-126.2-.1-5.8-.1-14.6-4.4-14.4-13.6.3-13.3-.2-102.3-.2-122 0-8.4 4.9-13.5 15.4-13.5 15 0 86.7-.1 121.2-.1 4 0 13.2 0 13.2-.3V214.2c0-13.1 5.5-43 28.7-64.6 17.7-16.5 42.3-26.8 69.4-26.8h162.9"
      id="pc2_svg__path1896"
    />
    <g
      id="pc2_svg__g1517"
      transform="translate(112.776 52.813) scale(.82242)"
      style={{
        strokeWidth: 1.21593,
      }}
    >
      <path
        className="pc2_svg__st20"
        d="M718.355 434.104c-1.3-12.6-11.2-22.3-23.4-23.2-10.7-.8-21.5-1.4-31.9-1.8-18.6-.8-37.4-1.1-56.1-1 1.2-27.4.4-55-2.5-82.2-1.3-12.2-10.8-21.7-22.7-22.5-40.5-2.9-81.6-3.5-122-1.8-10.1.4-20.4 1-30.7 1.8-11.8.9-21.4 10.3-22.7 22.5-4 38.2-4 76.9 0 115 1.3 12.2 10.8 21.7 22.7 22.6l2.4.2c3.4.2 6 3.2 6 6.7v22.7c0 5.4 2.9 10.3 7.6 12.7 1.9 1 4 1.5 6.1 1.5 2.9 0 5.8-1 8.3-2.9 4.6-3.6 9-7.3 13.1-11 1.9-1.8 2.1-4.8.4-6.8-1.7-2-4.6-2.2-6.6-.4-3.9 3.5-8.1 7.1-12.6 10.6-1.3 1.1-3 1.2-4.6.5-1.5-.8-2.4-2.3-2.4-4v-22.9c0-8.6-6.5-15.7-14.7-16.3l-2.4-.2c-7.3-.5-13.3-6.4-14.1-14-4-37.5-4-75.5 0-112.9.8-7.6 6.7-13.4 14.1-14 10.2-.7 20.4-1.3 30.4-1.8 40.1-1.7 80.8-1.2 121 1.8 7.3.5 13.3 6.4 14.1 14 4 37.5 4 75.5 0 113-.2 1.5-.5 3-1.1 4.5-2.3 5.4-7.2 9.1-12.9 9.5-26.8 2-54.2 2.9-81.2 2.7h-.1c-5.2 0-10 2.6-13 7-2.1 3.1-4.6 6.3-7.5 9.6-1.7 2-1.6 5 .3 6.8 1.9 1.8 4.9 1.6 6.6-.3 3.2-3.6 5.9-7.2 8.2-10.6 1.2-1.8 3.2-2.8 5.3-2.8h10.4c-1.4 29.1-.6 58.5 2.5 87.6.3 2.6.9 5.1 1.9 7.4 3.8 9.1 12 15.1 21.5 15.8 28.2 2 56.8 3 85.2 2.9 2.3 0 4.4 1.1 5.7 3 9.6 14.3 25.1 27.9 36.4 36.8 2.5 2 5.5 3 8.5 3 2.1 0 4.2-.5 6.2-1.5 4.8-2.5 7.8-7.4 7.8-13v-23.8c0-3.7 2.8-6.9 6.5-7.1h.1c.8-.1 1.6-.1 2.4-.2 12.2-.9 22.1-10.7 23.4-23.3.1-1.3.3-2.6.4-3.9.3-2.6-1.6-5-4.2-5.3-2.6-.3-4.9 1.6-5.1 4.3-.1 1.3-.3 2.6-.4 3.9-.8 8-7.1 14.2-14.8 14.7-.8.1-1.6.1-2.3.2h-.1c-8.5.6-15.2 7.9-15.2 16.7v23.5c0 1.9-1 3.5-2.6 4.4-1.6.8-3.5.7-4.9-.5-10.8-8.5-25.5-21.4-34.4-34.6-3-4.5-8-7.2-13.3-7.2h-.1c-28.1.1-56.5-.8-84.5-2.8-6-.4-11.2-4.3-13.6-10-.6-1.5-1-3-1.2-4.7-3-28.7-3.9-57.9-2.4-86.6 20.8-.3 41.7-1.2 62.2-2.7 9.2-.7 17.2-6.5 20.8-15.3 1-2.3 1.6-4.7 1.8-7.2.8-7.7 1.5-15.5 2-23.2 18.7-.2 37.6.2 56.2 1 10.4.4 21 1.1 31.6 1.8 7.7.6 14 6.7 14.8 14.7 3.3 31.4 4 63.3 1.9 94.7-.2 2.7 1.8 4.9 4.3 5.1h.3c2.4 0 4.5-1.9 4.6-4.5 2.4-32 1.7-64.5-1.7-96.4z"
        id="pc2_svg__path209"
        style={{
          opacity: 1,
          fill: "#fff",
          strokeWidth: 1.41281,
        }}
      />
      <path
        className="pc2_svg__st20"
        d="M675.355 503.404c.1-3.8-1.3-7.4-3.9-10.1-.5-.5-1-.9-1.5-1.3 1.4-2.2 2.1-4.8 2.1-7.6 0-3.8-1.4-7.4-4-10-2.6-2.7-6-4.2-9.7-4.2h-18.4l6.9-15.2c3.9-8.6.3-18.9-8-23-2.2-1.1-4.6-1.6-7.1-1.6-6.4 0-12.4 3.9-15.1 9.9l-4.3 9.4c-2.2 4.8-5.6 8.6-9.8 11.2-4.1 2.5-7.4 6.2-9.5 10.6-1.5-.7-3.1-1.1-4.8-1.1h-14c-6.5 0-11.8 5.5-11.8 12.2v58.5c0 6.7 5.3 12.2 11.8 12.2h14c2.2 0 4.3-.6 6.1-1.8 3.3 2.2 7.2 3.4 11.2 3.4h49.5c7.6 0 13.7-6.4 13.7-14.2 0-1.8-.3-3.5-.9-5.1v-.1c-.3-.8-.7-1.6-1.1-2.3 3.3-2.6 5.4-6.7 5.4-11.2 0-2.7-.7-5.3-2.1-7.6 3.1-2.6 5.2-6.6 5.3-11zm-101.1 40.2c-1.4 0-2.5-1.1-2.5-2.5v-58.6c0-1.4 1.1-2.5 2.5-2.5h14c1.4 0 2.5 1.1 2.5 2.5v58.6c0 1.4-1.1 2.5-2.5 2.5zm87.3-35.9h-3.2c-2.6 0-4.7 2.2-4.7 4.8 0 2.6 2.1 4.8 4.7 4.8 1.2 0 2.3.5 3.1 1.3.8.9 1.3 2 1.3 3.2 0 2.5-2 4.6-4.4 4.6h-3.3c-2.6 0-4.7 2.2-4.7 4.8 0 2.6 2.1 4.8 4.7 4.8 1.2 0 2.3.5 3.1 1.3.4.4.7.9 1 1.5v.1c.2.5.3 1.1.3 1.7 0 2.5-2 4.6-4.4 4.6h-49.5c-2.1 0-4-.6-5.8-1.6.2-.8.3-1.7.3-2.6v-58.6c0-2.2.4-4.3 1.2-6.4 1.3-2.9 3.3-5.3 6-6.9 5.9-3.6 10.5-8.9 13.5-15.4l4.3-9.4c1.2-2.7 3.8-4.4 6.7-4.4 1.1 0 2.1.2 3.1.7 3.7 1.8 5.3 6.3 3.5 10.1l-10 21.9c-.7 1.5-.6 3.2.2 4.5.1.1.1.2.2.3.9 1.4 2.3 2.2 3.9 2.2h25.7c1.2 0 2.3.5 3.1 1.3.8.9 1.3 2 1.3 3.2 0 2.5-2 4.6-4.4 4.6-2.6 0-4.7 2.2-4.7 4.8 0 2.6 2.1 4.8 4.7 4.8h3.1c1.3 0 2.5.5 3.4 1.5.8.9 1.3 2 1.3 3.2-.2 2.6-2.2 4.7-4.6 4.7z"
        id="pc2_svg__path211"
        style={{
          opacity: 1,
          fill: "#fff",
          strokeWidth: 1.41281,
        }}
      />
      <path
        className="pc2_svg__st20"
        d="M548.555 362.604c0-9.8-4.7-17.8-10.4-17.8s-10.4 8-10.4 17.8 4.7 17.8 10.4 17.8 10.4-8 10.4-17.8z"
        id="pc2_svg__path213"
        style={{
          opacity: 1,
          fill: "#fff",
          strokeWidth: 1.41281,
        }}
      />
      <path
        className="pc2_svg__st20"
        d="M483.155 362.604c0-9.8-4.7-17.8-10.4-17.8s-10.4 8-10.4 17.8 4.7 17.8 10.4 17.8c5.8 0 10.4-8 10.4-17.8z"
        id="pc2_svg__path215"
        style={{
          opacity: 1,
          fill: "#fff",
          strokeWidth: 1.41281,
        }}
      />
      <path
        className="pc2_svg__st20"
        d="M505.455 426.004c16.7 0 31.7-10.3 38.2-26.2 1-2.5-.1-5.3-2.5-6.3s-5.1.1-6.1 2.6c-5 12.3-16.7 20.3-29.6 20.3-13 0-24.6-8-29.6-20.3-1-2.5-3.7-3.6-6.1-2.6-2.4 1-3.5 3.9-2.5 6.3 6.5 15.9 21.5 26.2 38.2 26.2z"
        id="pc2_svg__path217"
        style={{
          opacity: 1,
          fill: "#fff",
          strokeWidth: 1.41281,
        }}
      />
    </g>
  </svg>
);
export default SvgPc2;
